export const ANNUAL_RETURN_TYPE = {
  ORGANISATION: 'organisation',
  REGION: 'region',
} as const;

export type AnnualReturnType =
  (typeof ANNUAL_RETURN_TYPE)[keyof typeof ANNUAL_RETURN_TYPE];

export const ANNUAL_RETURN_TYPE_OPTIONS = [
  { label: 'Organisation', value: ANNUAL_RETURN_TYPE.ORGANISATION },
  { label: 'Region', value: ANNUAL_RETURN_TYPE.REGION },
];
